var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPinkSpringWireV2 = function SvgPinkSpringWireV2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 635,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-141.361 541.525c31.819-84.276 133.005-220.222 283.201-89.798 187.745 163.031 390.081 297.28 601.799-58.955 123.199-217.24-416.861-248.289-211.081 87.505C738.339 816.071 1108.59-6.418 1443.82 17.532",
    stroke: "#F05",
    strokeWidth: 33
  })));
};
export default SvgPinkSpringWireV2;